import { httpRequest } from "@services/http";
import { JourneyPath } from "@models/journeyPath.model";

export interface UpdateJourneyPathPayload {
  name?: string;
  population_segment_id?: number | null;
}

export class CommandUpdateJourneyPath {
  async run(
    contractId: number,
    pricesheetId: number,
    pathId: number,
    payload: UpdateJourneyPathPayload,
  ): Promise<JourneyPath> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/finance/contracts/${contractId}/pricesheets/${pricesheetId}/journey-paths/${pathId}/`;
    const response = await httpRequest<any>(url, {
      method: "PATCH",
      body: JSON.stringify(payload),
    });
    return new JourneyPath(response);
  }
}
